import './parts/partners';

jQuery(function ($) {
	const form = document.querySelector("#resource-filter");

	if (form) {

		// blocks form submit
		form.addEventListener( 'submit', e => e.preventDefault());

		const search_field = document.querySelector("#search-resources-field");

		// listen for form submit
		form.querySelectorAll('select, input[type="radio"]').forEach((element) => element.addEventListener("change", filter_resources) );

		// Listen for search form
		let timeoutId;
		search_field.addEventListener("input", function (event) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => search_resources(event), 500 ); // Adjust the delay time (in milliseconds) as needed
		});

		function search_resources(e) {

			e.preventDefault();

			const field = document.querySelector("#search-resources-field");
			const form = document.querySelector("#resource-filter");
			const formdata = new FormData(form);

			if (field.value) {
				const data = {};
				data.page = 1;
				data.perpage = formdata.get("perpage");
				data.search = field.value;

				if( formdata.get("post_type") ){
					data.post_type = formdata.get("post_type");
				}

				$.ajax({
					type: "GET",
					url: restApi.url + "api/v1/resources/get",
					beforeSend: function (xhr) {
						xhr.setRequestHeader("X-WP-Nounce", restApi.nonce);
					},
					data: data,
				})
					.success(function (response) {
						if (response) {
							$("#filter-results").html(response.body);
							$("#resource-counter").text(response.total_found);

							var button = document.querySelector("#loadmore-resources");

							if (!button) {
								var button_html =
									'<div id="spinner" class="container"><div class="spinner"></div></div>';
								button_html +=
									'<a href="#loadmore" id="loadmore-resources" class="loadmore" style="visibility: hidden;">Load more</a>';
								$("#filter-container").append(button_html);
								var button = document.querySelector("#loadmore-resources");
							}

							if (response.page == response.max_pages) {
								button.style.display = "none";
							} else {
								document.querySelector('input[name="page"]').value =
									response.page;
								button.style.display = "inline-flex";
							}
						}
					})
					.fail(function (err) {
						console.log(err);
					});
			}
		}

		/**
		 *
		 * API request to get new resources
		 *
		 * @param {Event} e
		 */
		function filter_resources(e) {
			e.preventDefault();

			const formdata = new FormData(this.closest("form"));

			let data = {};
			data.page 		= 1;
			data.perpage 	= formdata.get("perpage");
			data.category 	= formdata.get("resource-category");
			data.type 		= formdata.get("type");
			data.mode 		= formdata.get("mode");
			data.priority 	= formdata.get("nrspp-priority");

			if( formdata.get("post_type") ){
				data.post_type = formdata.get("post_type");
			}

			// clear search field
			const field = document.querySelector("#search-resources-field");
			field.value = "";

			$.ajax({
				type: "GET",
				url: restApi.url + "api/v1/resources/get",
				beforeSend: function (xhr) {
					xhr.setRequestHeader("X-WP-Nounce", restApi.nonce);
				},
				data: data,
			})
				.success(function (response) {
					if (response.total_found > 0) {
						$("#filter-results").html(response.body);
						$("#resource-counter").text(response.total_found);
						var button = document.querySelector("#loadmore-resources");

						if (!button) {
							var button_html =
								'<div id="spinner" class="container"><div class="spinner"></div></div>';
							button_html +=
								'<a href="#loadmore" id="loadmore-resources" class="loadmore" style="visibility: hidden;">Load more</a>';
							$("#filter-container").append(button_html);
							var button = document.querySelector("#loadmore-resources");
						}

						if (response.page == response.max_pages) {
							button.style.display = "none";
						} else {
							document.querySelector('input[name="page"]').value =
								response.page;
							button.style.display = "inline-flex";
						}
					} else {
                        $("#resource-counter").text(response.total_found);
						$("#filter-results").html("<p>No Resources Found!</p>");
					}
				})
				.fail(function (err) {
					console.log(err);
				});
		}

		/**
		 *
		 * Set up the Observer for the load more button
		 * the rootMargin 100px makes it detect the button 100px before it's visible
		 * so we can start loading early
		 *
		 */
		function observe_loadmore_button() {
			const loadmore_button = document.querySelector("#loadmore-resources");
            loadmore_button.addEventListener("click", load_more_resources);
		}

		/**
		 *
		 * Ajax load more function
		 *
		 */
		function load_more_resources() {
			const spinner = $("#spinner");
			spinner.fadeIn();

			const search_field = document.querySelector("#search-resources-field");
			const button = document.querySelector("#loadmore-resources");
			const form = document.querySelector("#resource-filter");
            button.style.opacity = 0.5;

			const formdata = new FormData(form);

			let data = {};
			data.page = parseInt(formdata.get("page")) + 1;
			data.perpage = formdata.get("perpage");

			if (search_field.value) {
				data.search = search_field.value;
			} else {
				data.category = formdata.get("resource-category");
				data.type = formdata.get("type");
				data.mode = formdata.get("mode");
				data.priority = formdata.get("nrspp-priority");
			}

			if( formdata.get("post_type") ){
				data.post_type = formdata.get("post_type");
			}

			$.ajax({
				type: "GET",
				url: restApi.url + "api/v1/resources/get",
				beforeSend: function (xhr) {
					xhr.setRequestHeader("X-WP-Nounce", restApi.nonce);
				},
				data: data,
			})
				.success(function (response) {
					if (response.total_found > 0) {
						$("#filter-results").append(response.body);

						if (response.page == response.max_pages) {
							button.style.display = "none";
						} else {
							document.querySelector('input[name="page"]').value = response.page;
						}

						spinner.fadeOut();
                        button.style.opacity = 1;
						return observe_loadmore_button(); // start looking for the load more button again
					}
				})
				.fail(function (err) {
					console.log(err);
				});
		}

		// initialize on first page load
		observe_loadmore_button();
	}
});
